var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSikana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    fill: "#FAF3F3",
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 31.3382C16.5 27.4351 20.6284 24.0714 26 24.0714C31.3716 24.0714 35.5 27.4351 35.5 31.3382C35.5 32.3208 35.246 32.9483 34.849 33.3726C34.4426 33.8071 33.8251 34.0946 32.9709 34.2692C32.1171 34.4437 31.0809 34.495 29.8905 34.4996C29.2978 34.502 28.6747 34.4928 28.0229 34.483L27.9787 34.4823C27.342 34.4727 26.6791 34.4628 26 34.4628C25.3209 34.4628 24.658 34.4727 24.0213 34.4823L23.9771 34.483C23.3253 34.4928 22.7022 34.502 22.1095 34.4996C20.9191 34.495 19.8829 34.4437 19.0291 34.2692C18.1749 34.0946 17.5574 33.8071 17.151 33.3726C16.754 32.9483 16.5 32.3208 16.5 31.3382Z",
    fill: "#C4C4C4",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2142 19.2857C22.2142 17.1949 23.9092 15.5 26 15.5C28.0908 15.5 29.7857 17.1949 29.7857 19.2857C29.7857 21.3765 28.0908 23.0714 26 23.0714C23.9092 23.0714 22.2142 21.3765 22.2142 19.2857Z",
    fill: "#C4C4C4",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7.42319,
    y2: -0.5,
    transform: "matrix(0.647517 0.762051 -0.647517 0.762051 32.006 17)",
    stroke: "black",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7.44814,
    y2: -0.5,
    transform: "matrix(0.63175 -0.775172 0.663114 0.748518 32.8557 22.7736)",
    stroke: "black",
    strokeOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9_212",
    x: 12,
    y: 15,
    width: 29.561,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_212"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_212",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSikana);
export default __webpack_public_path__ + "static/media/Sikana.6ecef87e6414795d7eb0743a45a2989e.svg";
export { ForwardRef as ReactComponent };